import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ButtonColorTestPage() {
  return <div className="w-full min-h-screen bg-white py-12 px-6" data-id="element-728" data-mp="6jgzctnzss6y">
      <div className="max-w-4xl mx-auto" data-id="element-729" data-mp="kbwul8anjlxb">
        {/* Back button */}
        <div className="mb-8" data-id="element-730" data-mp="gbmlvnvh6her">
          <Link to="/" className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-731" data-mp="gco0g2bp9m18">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-732" data-mp="3org54ah6y6zi" />
            <span data-id="element-733" data-mp="3jsv4wb1xvnb2">Go Back</span>
          </Link>
        </div>
        {/* Main content */}
        <div className="bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-734" data-mp="1n00b4f98tf3">
          <h1 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-735" data-mp="3st1dpjmozz3w">
            CTA Button Color Options
          </h1>
          <div className="space-y-12" data-id="element-736" data-mp="1d0lz7hax29dt">
            {/* Sunset Coral */}
            <div className="space-y-6" data-id="element-737" data-mp="182srgjtyt7bf">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-738" data-mp="181r8lt6pjgj5">
                Sunset Coral (#f46b5b)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-739" data-mp="3nob5t5c991s0">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-740" data-mp="3rn24vi0a6thr">
                  <span data-id="element-741" data-mp="5gdd5k7zaoty">Primary Button</span>
                </button>
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-742" data-mp="5ej1kwilk92j">
                  <span data-id="element-743" data-mp="38xvjtoc0lpss">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-744" data-mp="3dwf99ypthjpw" />
                </button>
                <button className="border-2 border-[#f46b5b] text-[#f46b5b] px-6 py-3 rounded-md font-medium hover:bg-[#f46b5b] hover:text-white transition-colors" data-id="element-745" data-mp="3dv45hywdgbys">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Golden Amber */}
            <div className="space-y-6" data-id="element-746" data-mp="2q502ntr0cg8u">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-747" data-mp="2i5wtnfh4wra2">
                Golden Amber (#f6b736)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-748" data-mp="2e3i98qxthjgo">
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-749" data-mp="2e2qn06q40y32">
                  <span data-id="element-750" data-mp="2mxn6bs3jnr4n">Primary Button</span>
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-751" data-mp="1z8c2u2ut7imt">
                  <span data-id="element-752" data-mp="2956wo8g50uur">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-753" data-mp="2971mo169nd5p" />
                </button>
                <button className="border-2 border-[#f6b736] text-[#f6b736] px-6 py-3 rounded-md font-medium hover:bg-[#f6b736] hover:text-white transition-colors" data-id="element-754" data-mp="246443nhcgh3o">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Bright Sky Blue */}
            <div className="space-y-6" data-id="element-755" data-mp="11di4oaojrh1m">
              <h2 className="text-xl font-semibold text-gray-800" data-id="element-756" data-mp="11cgfl2ap4u0w">
                Bright Sky Blue (#4dc4f7)
              </h2>
              <div className="flex flex-wrap gap-6" data-id="element-757" data-mp="sd3649mko5g6">
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-758" data-mp="seeigxu32liw">
                  <span data-id="element-759" data-mp="1l1ijystywhpx">Primary Button</span>
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-760" data-mp="1p3cf6lle8tip">
                  <span data-id="element-761" data-mp="1b9uxl6c9pqvb">Get Started</span>
                  <ArrowRightIcon size={18} data-id="element-762" data-mp="1gaikpgxdlnk9" />
                </button>
                <button className="border-2 border-[#4dc4f7] text-[#4dc4f7] px-6 py-3 rounded-md font-medium hover:bg-[#4dc4f7] hover:text-white transition-colors" data-id="element-763" data-mp="1g8pfm62evbed">
                  Secondary Button
                </button>
              </div>
            </div>
            {/* Comparison Section */}
            <div className="pt-10 border-t border-gray-200" data-id="element-764" data-mp="k35u4njtsjjm">
              <h2 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-765" data-mp="f5np388xiogw">
                Side-by-Side Comparison
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-766" data-mp="b6ork8pj1tzh">
                <button className="bg-[#f46b5b] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-767" data-mp="67bsmpldswgj">
                  <span data-id="element-768" data-mp="yvhejfo68rhy">Sunset Coral</span>
                  <ArrowRightIcon size={18} data-id="element-769" data-mp="ywj1ahejv2fi" />
                </button>
                <button className="bg-[#f6b736] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-770" data-mp="u2etjvxgmqdd">
                  <span data-id="element-771" data-mp="1mk8zpn3cg9l8">Golden Amber</span>
                  <ArrowRightIcon size={18} data-id="element-772" data-mp="1mlbqzw4kwe1o" />
                </button>
                <button className="bg-[#4dc4f7] text-white px-6 py-3 rounded-md font-medium flex items-center justify-center space-x-2 hover:bg-opacity-90 transition-colors" data-id="element-773" data-mp="1hs94g7y7y4uz">
                  <span data-id="element-774" data-mp="1u306m1ylgxtx">Bright Sky Blue</span>
                  <ArrowRightIcon size={18} data-id="element-775" data-mp="1u3s27cs6yvk7" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}